import { Reveal } from "./Reveal";

export const ManifestoSection = () => (
  <section
    data-testid="manifesto-section"
    className="relative py-32 lg:py-48 bg-[#1F1E1B] overflow-hidden"
  >
    <div
      aria-hidden="true"
      className="absolute inset-x-0 top-0 h-72 bg-[radial-gradient(ellipse_at_top,rgba(246,244,240,0.05),transparent_65%)]"
    />
    <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
      <Reveal>
        <span className="font-serif text-7xl lg:text-8xl leading-none text-[#F6F4F0]/25 select-none" aria-hidden="true">
          &ldquo;
        </span>
        <blockquote
          data-testid="manifesto-quote-text"
          className="mt-2 font-serif text-2xl sm:text-3xl lg:text-[2.6rem] font-light leading-snug text-[#F6F4F0]"
        >
          True advisory is defined as much by the transactions we counsel{" "}
          <span className="italic text-[#C9C4B8]">against</span> as by those we bring to completion —
          pursued with discretion, independence and an uncompromising dedication to our clients'
          interests.
        </blockquote>
        <div className="mt-12 flex items-center justify-center gap-4">
          <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#F6F4F0]/40" />
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#F6F4F0]/50" aria-hidden="true" />
          <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#F6F4F0]/40" />
        </div>
        <p className="mt-6 font-sans text-[10px] uppercase tracking-[0.32em] text-[#A8A49B]">
          The Partner Desk — Mayfair, London
        </p>
      </Reveal>
    </div>
  </section>
);
